<template>
  <div v-loading="loading">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="200px">

      <div class="common-form">修改视力数据</div>
      <el-form-item label="所在区域"  >
        <div style="display: flex;">
          <el-select @change="provinceChange" v-model="form.province_name" filterable  placeholder="请选择省份">
            <el-option
              v-for="item in province_options"
              :key="item.id"
              :label="item.name"
              :value="item">
            </el-option>
          </el-select>
          <el-select @change="cityChange" v-model="form.city_name" filterable placeholder="请选择城市" :disabled="lock_city">
            <el-option
              v-for="item in city_options"
              :key="item.id"
              :label="item.name"
              :value="item">
            </el-option>
          </el-select>
          <el-select @change="regionChange" v-model="form.region_name" filterable placeholder="请选择区域" :disabled="lock_region">
            <el-option
              v-for="item in region_options"
              :key="item.id"
              :label="item.name"
              :value="item">
            </el-option>
          </el-select>
        </div>
      </el-form-item>
      <el-form-item label="学校名称" >
        <el-input v-model="form.school_name" placeholder="请输入学校名称" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="年级">
        <el-input v-model="form.grade_name" placeholder="请输入年级"  class="max-w460"></el-input>
      </el-form-item>

      <el-form-item label="班级 ">
        <el-input v-model="form.class_name" placeholder="请输入班级" type="text" maxlength="10" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="学生姓名">
        <el-input v-model="form.student_name" placeholder="请输入学生姓名"  maxlength="10" class="max-w460"></el-input>
      </el-form-item>

      <el-form-item label="性别">
        <el-select v-model="form.gender" placeholder="请选择性别" style="width: 108px;">
          <el-option v-for="(item, index) in sex" :key="index" :label="item" :value="index"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="出生日期 " >
        <el-date-picker v-model="form.birthday" type="date" value-format="yyyy-MM-dd" placeholder="请选择出生日期"></el-date-picker>
      </el-form-item>
      <el-form-item label="身份证号">
        <el-input v-model="form.id_card" placeholder="请输入身份证号" oninput="if(value.length>18)value=value.slice(0,18)"  class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="学籍号">
        <el-input v-model="form.student_number" placeholder="请输入学籍号"  class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="家长姓名">
        <el-input v-model="form.parents_name" placeholder="请输入家长姓名"  maxlength="10" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="家长手机号">
        <el-input v-model="form.mobile" placeholder="请输入家长手机号"  oninput="if(value.length>11)value=value.slice(0,11)" type="number" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="居住地址">
        <el-input v-model="form.residential_address" placeholder="请输入居住地址"   class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="左眼视力（裸眼）">
        <el-input v-model="form.left_eyesight" placeholder="请输入左眼视力"  oninput="if(value.length>3)value=value.slice(0,3)"type="number" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="右眼视力（裸眼）">
        <el-input v-model="form.right_eyesight" placeholder="请输入右眼视力" oninput="if(value.length>3)value=value.slice(0,3)"type="number"  class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="双眼视力（裸眼）">
        <el-input v-model="form.double_eyesight" placeholder="请输入双眼视力" oninput="if(value.length>3)value=value.slice(0,3)"type="number"  class="max-w460"></el-input>
      </el-form-item>

      <!--提交-->
      <div class="common-button-wrapper">
        <el-button type="info" size="small" @click="cancelFunc" :loading="loading">取消</el-button>
        <el-button type="primary" size="small" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
  import VisionApi from '@/api/vision.js';
  import {formatModel} from '@/utils/base.js'
  export default {
    data() {
      return {
        /*form表单数据*/
        form: {
          /*ID*/
          vision_id:'',
          /*省市区*/
          province_id:'',
          province_name:'',
          city_id:'',
          city_name:'',
          region_id:'',
          region_name:'',

          /*数据*/
          school_name:'',
          grade_name:'',
          class_name:'',
          student_name:'',
          parents_name:'',
          residential_address:'',
          student_number:'',
          id_card:'',
          birthday:'',
          gender:'',
          left_eyesight:'',
          right_eyesight:'',
          double_eyesight:'',
          test_time:'',
          mobile:'',
        },

        /* 城市锁 */
        lock_city:true,
        /* 区域锁 */
        lock_region:true,
        province_options:{},
        city_options:{},
        region_options:{},
        /*性别列表*/
        sex: ['女', '男'],
        /*是否正在加载*/
        loading: true,

      };
    },
    created() {
      let vision_id = this.$route.query.vision_id;
      this.getAddressList();
      this.getData(vision_id);
    },

    methods: {
      getData(vision_id) {
        let self = this;
        VisionApi.visionDetail(
          {
            vision_id: vision_id
          },
          true
        )
          .then(data => {
            let obj={};
            obj = data.data.detail;
            //选中

            self.form=formatModel(self.form,obj);
            let formInline = data.data.detail;
            console.log(formInline);
            if (formInline.province_id > 0){
              self.lock_city = false
              self.form.province_name = formInline.province_name
              self.form.province_id = formInline.province_id
              self.cityList(formInline.province_id)
            }
            if (formInline.city_id > 0){
              self.lock_region = false
              self.form.city_name = formInline.city_name
              self.form.city_id = formInline.city_id
              self.form.region_name = formInline.region_name
              self.form.region_id = formInline.region_id
              self.regionList(formInline.city_id);
            }
            self.loading=false;
          })
          .catch(error => {
            self.loading=false;
          });
      },


      /* 省份获取 */
      getAddressList(){
        let self = this;
        VisionApi.provinceList('',true)
          .then(data => {
            self.province_options = data.data.list;
            console.log(self.province_options)
          })
          .catch(error => {

          });
      },
      /* 市列表 */
      cityList(id){
        let self = this;
        let Params = {}
        Params.province_id = id
        VisionApi.city_list(Params,true)
          .then(data => {
            self.city_options = data.data.list
          })
          .catch(error =>{

          });
      },
      /* 区列表 */
      regionList(id){
        let self = this;
        let Params = {}
        Params.region_id = id
        VisionApi.region_list(Params,true)
          .then(data => {
            console.log(data)
            self.region_options = data.data.list
          })
          .catch(error =>{

          });
      },
      /* 选择省 */
      provinceChange(selVal){
        let self = this
        self.form.province_name = selVal.name
        self.form. province_id = selVal.id
        self.form.city_name = ""
        self.form.city_id = ""
        self.form.region_id = ""
        console.log(self.lock_city)
        self.lock_city = false
        console.log(self.lock_city)
        if (!self.lock_region){
          self.lock_region = true
          self.form.region_name = ""
        }
        self.cityList(selVal.id)
      },
      /* 选择市 */
      cityChange(selVal){
        let self = this
        self.form.city_name = selVal.name
        self.form.city_id = selVal.id
        self.form.region_name = ""
        self.form.region_id = ""
        if (self.lock_region){
          self.lock_region = false
        }
        self.regionList(selVal.id);
      },
      /* 选择区 */
      regionChange(selVal){
        let self = this
        self.form.region_name = selVal.name
        self.form.region_id = selVal.id
        /* 层级太深，需要手动刷新渲染 */
        self.$forceUpdate();
        console.log(self.form.region_name)
      },


      /*修改*/
      onSubmit() {
        let self = this;
        let form = self.form;
        self.$refs.form.validate(valid => {
          if (valid) {
            self.loading = true;
            VisionApi.editVision(form, true)
              .then(data => {
                self.loading = false;
                self.$message({
                  message: '恭喜你，修改成功',
                  type: 'success'
                });
                self.$router.push('/plus/vision/index');
              })
              .catch(error => {
                self.loading = false;
              });
          } else {
            self.loading = false;
          }
        });
      },

      /*取消*/
      cancelFunc(){
        this.$router.push({
          path:'/plus/vision/index',
        });
      }
    }
  };
</script>

<style lang="scss" scoped>
  .product-add {
    padding-bottom: 50px;
  }

  .tips {
    color: #ccc;
  }
</style>



// WEBPACK FOOTER //
// src/views/plus/vision/vision/edit.vue